import { Routes } from '@angular/router';
import { AuthComponent } from '../features/auth/pages/auth.component';
import { SchoolLayoutComponent } from '../layouts/school/school.component';
import { ERole } from '../features/auth/enums/role.enum';
import { CoursesComponent } from '../features/courses/courses.component';
import { CourseDetailComponent } from '../features/courses/pages/course-detail/course-detail.component';
import { MyStudiesComponent } from '../features/courses/pages/my-studies/my-studies.component';
import { AuthGuard } from '../core/guards/auth.guard';
import { RoleGuard } from '../core/guards/role.guard';
import {
  layoutRoleChildGuard,
  layoutRoleGuard,
} from '../core/guards/layout-role.guard';
import { MyCoursesComponent } from '../features/courses/pages/my-courses/my-courses.component';
import { ForgotPasswordRequestComponent } from '../features/auth/pages/forgot-password-request/forgot-password-request.component';
import { UpdatePasswordComponent } from '../features/auth/pages/update-password/update-password.component';

export function getSchoolRoutes(): Routes {
  return [
    {
      path: '',
      component: SchoolLayoutComponent,
      data: {
        layout: 'school',
        layoutRoles: [ERole.TEACHER, ERole.DIRECTOR, ERole.SCHOOL],
      },
      canActivate: [layoutRoleGuard],
      canActivateChild: [layoutRoleChildGuard],
      children: [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: 'courses',
        },
        {
          path: 'auth',
          component: AuthComponent,
        },
        {
          path: 'auth/forgot-password',
          component: ForgotPasswordRequestComponent,
        },
        {
          path: 'auth/update-password',
          component: UpdatePasswordComponent,
        },
        {
          path: 'courses',
          canActivate: [AuthGuard, RoleGuard],
          component: CoursesComponent,
          data: { roles: [ERole.TEACHER, ERole.DIRECTOR] },
          children: [
            {
              path: '',
              pathMatch: 'full',
              redirectTo: 'my-studies',
            },
            {
              path: 'my-studies',
              component: MyStudiesComponent,
            },
            {
              path: 'my-courses',
              component: MyCoursesComponent,
            },

            {
              path: ':id',
              component: CourseDetailComponent,
            },
          ],
        },

        {
          path: '**',
          redirectTo: 'courses',
        },
      ],
    },
  ];
}
